import { ICorporationResponse } from '@kcftech/prometheus-client';
import { sdClient } from 'contexts/SDKClientContext';
import {
    BaseDataSourceOptions,
    DataSourceQuery,
    DataSourceSort,
} from 'custom_hooks/data_hooks/data_source/data_source';
import {
    PagedDataSource,
    usePagedDataSource,
} from 'custom_hooks/data_hooks/data_source/usePagedDataSource';
import { buildOrderBy, Filter, toDataSourceResult } from 'utils/query_v3';

export const defaultCorporationsSort: DataSourceSort[] = [{ field: 'Name', dir: 'asc' }];

export type CorporationsFilter = Readonly<{
    active?: boolean;
    nameSearch: string | undefined;
    corporationId?: string;
}>;

export type UseCorporationsDataSourceOptions = BaseDataSourceOptions<
    ICorporationResponse,
    CorporationsFilter
>;

export type CorporationsDataSource = PagedDataSource<
    ICorporationResponse,
    CorporationsFilter
>;

const getAllCorporations: DataSourceQuery<ICorporationResponse, CorporationsFilter> = ({
    filter: { nameSearch, active, corporationId },
    sort,
    page,
    pageLimit,
}) => {
    const filter = Filter.and(
        active !== undefined ? Filter.eq('Active', active) : undefined,
        corporationId ? Filter.eq('Id', corporationId) : undefined,
    );
    const orderBy = buildOrderBy(sort);
    return toDataSourceResult(
        sdClient.getCorporations({ filter, page, pageLimit, orderBy, nameSearch }),
    );
};

export function usePagedCorporationsDataSource({
    defaultSort = defaultCorporationsSort,
    ...options
}: UseCorporationsDataSourceOptions): CorporationsDataSource {
    return usePagedDataSource({
        defaultSort,
        ...options,
        query: getAllCorporations,
    });
}
